import { Directive, Binding, Inject } from '../annotations';

@Directive({
	selector: 'background-image'
})
export class BackgroundImageDirective {
	@Binding('@') backgroundImage: string;
	@Binding('<') speed: number;

	constructor(@Inject('$element') private $element: ng.IAugmentedJQuery) {
	}

	$onInit(): void {
		//if speed is specified, use the parallax effect
		if (this.speed) {
			this.$element.parallax({
				imageSrc: this.backgroundImage,
				speed: this.speed
			});
		//otherwise use a simple background cover
		} else {
			this.$element.addClass('background-cover');
			this.$element.css('backgroundImage', `url(${this.backgroundImage})`);
		}
	}
}



/** WEBPACK FOOTER **
 ** ./app/common/background-image.ts
 **/